<ng-container *ngIf="loaded">
	<div *ngIf="user" [ngClass]="{ 'dark-theme': (darkTheme.isEnabled$ | async) }">
		<!-------- KIOSK MODE SETTINGS ------->
		<ng-container *ngIf="isKioskModeSettingsPage && !isKioskMode">
			<div
				class="bar"
				appNavbarElementSender
				[ngStyle]="{
					background: darkTheme.getColor({ dark: '#0F171E', white: !isKioskMode ? '#FFFFFF' : 'transparent' }),
					'border-bottom': (darkTheme.isEnabled$ | async) ? '1px solid #7083A0' : 'none'
				}"
				#navbar>
				<div class="teacherNav"></div>
				<div class="user-info" style="flex-direction: row">
					<div class="options-wrapper">
						<ng-container *ngTemplateOutlet="staffIconButton"></ng-container>
					</div>
				</div>
			</div>
		</ng-container>

		<!-- TOP BAR - KIOSK, STAFF OR STUDENT -->
		<div class="host" [ngClass]="(isHelpCenterOpen$ | async) == true ? mediaClass : ''">
			<!-------- KIOSK MODE ------->
			<ng-container *ngIf="isKioskMode">
				<div
					class="bar kiosk-bar"
					appNavbarElementSender
					[ngStyle]="{
						background: darkTheme.getColor({ dark: '#0F171E', white: 'transparent' }),
						'border-bottom': (darkTheme.isEnabled$ | async) ? '1px solid #7083A0' : 'none'
					}"
					#navbar>
					<ng-container *ngTemplateOutlet="kioskLogoTemplate"></ng-container>

					<div class="teacherNav"></div>

					<ng-container *ngIf="isAttendanceEnabled">
						<span class="justGotHere">Just got here?</span>
						<div class="checkin-btn" role="button" (click)="openKioskCheckIn()">
							<img class="checkin-img" [src]="'./assets/Check (White).svg' | resolveAsset" alt="check icon" />
							<span>Check In</span>
						</div>
					</ng-container>

					<div class="user-info" style="flex-direction: row">
						<div class="options-wrapper">
							<app-white-round-button
								[size]="'regular'"
								[icon]="'Settings'"
								[color]="'Navy'"
								(buttonClick)="showOptions($event)"></app-white-round-button>
						</div>
					</div>
				</div>
			</ng-container>

			<!-------- STAFF TOP BAR (DESKTOP AND MOBILE) ------->
			<ng-container *ngIf="!isKioskMode && !isKioskModeSettingsPage && (isStaff || isAssistant)">
				<div class="bar" appNavbarElementSender #navbar>
					<sp-top-nav-bar [isContained]="true"></sp-top-nav-bar>
					<!-------- Pro Upsell Cleanup Marker ------->
					<app-upsell-modal
						*ngIf="proTrialService.modalToShow$ | async as modalType"
						[type]="modalType">
					</app-upsell-modal>
				</div>
			</ng-container>

			<!-------- STUDENT ------->
			<ng-container *ngIf="!isKioskMode && !isKioskModeSettingsPage && isStudent">
				<div class="bar" appNavbarElementSender #navbar>
					<div class="tw-grow tw-h-full tw-flex tw-flex-row tw-items-center tw-gap-4 tw-px-4 tw-bg-white">
						<div class="logo">
							<div class="logo-icon" appCrossPointerEventTarget>
								<img [src]="'./assets/Smartpass Logo (Green).svg'" alt="logo" />
							</div>
						</div>

						<sp-nav-tabs [disableKeyboardShortcuts]="dialog.openDialogs.length > 0"></sp-nav-tabs>

						<div #passButtonsContainer class="tw-flex tw-flex-row tw-gap-2 max-sm:tw-hidden">
							<app-create-pass-button
								[title]="screenService.windowWidth < screenService.largeDevicesBreakPoint ? '' : 'Schedule Pass'"
								(onClick)="showMainForm(true)"
								[width]="screenService.windowWidth < screenService.largeDevicesBreakPoint ? '51px' : ''"
								[icon]="screenService.windowWidth < screenService.largeDevicesBreakPoint ? 'Clock (Gray).svg' : ''">
							</app-create-pass-button>
							<app-create-pass-button
								cdkOverlayOrigin
								#secondOverlayTrigger="cdkOverlayOrigin"
								[title]="screenService.windowWidth < screenService.largeDevicesBreakPoint ? '' : 'Create Pass'"
								[backgroundColor]="'#00B476'"
								[width]="screenService.windowWidth < screenService.largeDevicesBreakPoint ? '51px' : ''"
								[hoverBackgroundColor]="'#009964'"
								[hoverText]="createButtonTooltipText"
								(mouseenter)="showStudentNoFlyTimeTooltip()"
								(mouseleave)="closeStudentNoFlyTimeTooltip()"
								[icon]="'add-icon.svg'"
								[textColor]="'#fff'"
								[disabled]="
									(noFlyTimeActive && isStudent) ||
									emergencyService.isEmergencyActivated.value ||
									(isCreatePassButtonDisabled$.asObservable() | async)
								"
								(onClick)="this.showMainForm(false)">
							</app-create-pass-button>
							<ng-template
								cdkConnectedOverlay
								[cdkConnectedOverlayOrigin]="secondOverlayTrigger"
								[cdkConnectedOverlayOpen]="isOpenStudentNoFlyTimeTooltip | async"
								[cdkConnectedOverlayWidth]="198"
								[cdkConnectedOverlayHeight]="89"
								[cdkConnectedOverlayPositions]="noFlyTimeTooltipPosition">
								<app-no-fly-time-tooltip
									*ngIf="noFlyTimeActive && isStudent && !hasActivePassRequest"
									[noFlyTimes]="noFlyTimes"
									[tooltipType]="'student'"
									[isStaff]="!isStudent"
									[currentNoFlyTimeIndex]="currentNoFlyTimeIndex"
									(mouseleave)="closeStudentNoFlyTimeTooltip()"
									(mouseover)="showStudentNoFlyTimeTooltip()">
								</app-no-fly-time-tooltip>
							</ng-template>
						</div>

						<app-white-round-button
							*ngIf="!areProfilePicturesEnabled"
							[size]="'regular'"
							[icon]="'Settings'"
							(buttonClick)="showOptions($event)"></app-white-round-button>
						<app-user-profile-button *ngIf="areProfilePicturesEnabled" [userProfileImage]="user.profile_picture" (buttonClick)="showOptions($event)">
						</app-user-profile-button>
					</div>
				</div>
			</ng-container>
		</div>

		<!-------- STAFF BOTTOM BAR (MOBILE ONLY) ------->
		<div
			class="host"
			*ngIf="(isStaff || isAssistant) && !hideButtons && screenService.windowWidth < navBarBreakPoint"
			[ngClass]="[isIOSTablet ? 'ios-teacherNav-mobile' : 'teacherNav-mobile', (isHelpCenterOpen$ | async) == true ? mediaClass : '']">
			<sp-bottom-nav-bar [isContained]="true"></sp-bottom-nav-bar>
		</div>
	</div>
</ng-container>

<ng-template #kioskLogoTemplate>
	<div class="logo logo-kiosk tw-gap-3" *ngIf="kioskModeRoomIcon">
		<div
			class="logo-icon logo-icon-kiosk"
			appCrossPointerEventTarget
			(pointerClickEvent)="updateTab('passes')"
			[ngStyle]="{ background: 'radial-gradient(circle at 73% 71%, ' + kioskModeRoomIconGradientColor + ')' }">
			<img [src]="kioskModeRoomIcon | resolveAsset" alt="logo" />
		</div>
		<div class="kiosk-title">{{ kioskModeLocation.title }}</div>
	</div>
</ng-template>

<ng-template #staffIconButton>
	<app-icon-button
		*ngIf="!areProfilePicturesEnabled"
		[newIconButton]="true"
		[srcString]="'Settings'"
		[color]="'Navy'"
		[size]="20"
		(clickEvent)="showOptions($event)"></app-icon-button>

	<app-user-profile-button
		*ngIf="areProfilePicturesEnabled"
		[userProfileImage]="user.profile_picture"
		(buttonClick)="showOptions($event)"></app-user-profile-button>
</ng-template>
